module.exports = fox._r("images/press/icon-blog-date.png", __webpack_public_path__ + "_/common/images/press/icon-blog-date.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-blog-date.png
// module id = 379
// module chunks = 2